// Library Methods
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import SharedTabs from "src/components/shared/navigation/SharedTabs/SharedTabs";
import SnackbarMessage from "src/components/shared/alerts/SnackbarMessage/SnackbarMessage";
import ClinicSettings from "./ClinicSettings/ClinicSettings";
import UserManagement from "./UserManagement/UserManagement";

// Styles
import { PageContainerWrapper } from "src/styles/mui/muiStylesHelper";

// Contexts
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";
import ClinicSettingsProvider from "src/contexts/clinic/ClinicSettingsContext";

const Settings = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { snackbarInfo, setSnackbarInfo } = useSnackbarContext();

  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = useMemo(
    () => [
      { id: 0, label: t("Settings"), showTab: true },
      {
        id: 1,
        label: t("User Management"),
        showTab: true,
      },
    ],
    [t]
  );

  return (
    <Box
      sx={{
        ...PageContainerWrapper(theme),
        gap: "20px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Typography fontWeight={600} fontSize="16px">
          {selectedTab === 0 && t("Settings")}
          {selectedTab === 1 && t("User Management")}
        </Typography>
        <Typography>
          {t("Any changes to your settings will be autosaved.")}
        </Typography>
      </Box>

      <SharedTabs
        tabs={tabs}
        selectedTabId={selectedTab}
        onChange={(tabId) => setSelectedTab(tabId)}
      />

      {selectedTab === 0 && (
        <ClinicSettingsProvider>
          <ClinicSettings />
        </ClinicSettingsProvider>
      )}
      {selectedTab === 1 && <UserManagement />}

      {/* Snackbar success and error messages */}
      <SnackbarMessage
        snackbarInfo={snackbarInfo}
        setSnackbarInfo={setSnackbarInfo}
      />
    </Box>
  );
};

export default Settings;
